import React from "react";
import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import icons from "../../assets/icons/icon-collection.svg";
import "./MobileActionMenu.scss";

const MobileActionMenu = ({ open, onClose, onPostJob, onRequestHiring, onUploadJobs }) => {
  const handleAction = (action) => {
    onClose();
    action();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      PaperProps={{
        style: {
          backgroundColor: "#f5f7fa",
        },
      }}
    >
      <div className="mobile-action-menu">
        <div className="mobile-action-menu-header">
          <h2>Create</h2>
          <IconButton onClick={onClose} className="close-button">
            <Close />
          </IconButton>
        </div>

        <DialogContent className="mobile-action-menu-content">
          <div className="action-card" onClick={() => handleAction(onPostJob)}>
            <div className="action-icon post-job">
              <svg width="24" height="24">
                <use href={`${icons}#jobs`}></use>
              </svg>
            </div>
            <div className="action-content">
              <h3>Post a Job</h3>
              <p>Create a new job posting from template or scratch</p>
            </div>
            <div className="action-arrow">
              <svg width="12" height="20">
                <use href={`${icons}#arrow`}></use>
              </svg>
            </div>
          </div>

          <div className="action-card" onClick={() => handleAction(onRequestHiring)}>
            <div className="action-icon request-hiring">
              <svg width="24" height="24">
                <use href={`${icons}#invitees`}></use>
              </svg>
            </div>
            <div className="action-content">
              <h3>Request Hiring Support</h3>
              <p>Get expert help with your recruitment needs</p>
            </div>
            <div className="action-arrow">
              <svg width="12" height="20">
                <use href={`${icons}#arrow`}></use>
              </svg>
            </div>
          </div>

          <div className="action-card" onClick={() => handleAction(onUploadJobs)}>
            <div className="action-icon upload-jobs">
              <svg width="20" height="24" viewBox="0 0 20 24" fill="none">
                <path fillRule="evenodd" clipRule="evenodd" d="M1.2019 1.03589C1.8114 0.426394 2.63805 0.0839844 3.5 0.0839844H12.1667C12.454 0.0839844 12.7295 0.198121 12.9327 0.401285L19.4327 6.90129C19.6359 7.10445 19.75 7.38 19.75 7.66732V20.6673C19.75 21.5293 19.4076 22.3559 18.7981 22.9654C18.1886 23.5749 17.362 23.9173 16.5 23.9173H3.5C2.63805 23.9173 1.8114 23.5749 1.2019 22.9654C0.59241 22.3559 0.25 21.5293 0.25 20.6673V3.33398C0.25 2.47203 0.59241 1.64538 1.2019 1.03589ZM3.5 2.25065C3.21268 2.25065 2.93713 2.36479 2.73397 2.56795C2.5308 2.77112 2.41667 3.04667 2.41667 3.33398V20.6673C2.41667 20.9546 2.5308 21.2302 2.73397 21.4333C2.93713 21.6365 3.21268 21.7506 3.5 21.7506H16.5C16.7873 21.7506 17.0629 21.6365 17.266 21.4333C17.4692 21.2302 17.5833 20.9546 17.5833 20.6673V8.11605L11.7179 2.25065H3.5Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M12.1667 0.0839844C12.765 0.0839844 13.25 0.569009 13.25 1.16732V6.58398H18.6667C19.265 6.58398 19.75 7.06901 19.75 7.66732C19.75 8.26563 19.265 8.75065 18.6667 8.75065H12.1667C11.5684 8.75065 11.0833 8.26563 11.0833 7.66732V1.16732C11.0833 0.569009 11.5684 0.0839844 12.1667 0.0839844Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M4.58333 13.084C4.58333 12.4857 5.06836 12.0007 5.66667 12.0007H14.3333C14.9316 12.0007 15.4167 12.4857 15.4167 13.084C15.4167 13.6823 14.9316 14.1673 14.3333 14.1673H5.66667C5.06836 14.1673 4.58333 13.6823 4.58333 13.084Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M4.58333 17.4173C4.58333 16.819 5.06836 16.334 5.66667 16.334H14.3333C14.9316 16.334 15.4167 16.819 15.4167 17.4173C15.4167 18.0156 14.9316 18.5006 14.3333 18.5006H5.66667C5.06836 18.5006 4.58333 18.0156 4.58333 17.4173Z" fill="white"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M4.58333 8.75065C4.58333 8.15234 5.06836 7.66732 5.66667 7.66732H7.83333C8.43164 7.66732 8.91667 8.15234 8.91667 8.75065C8.91667 9.34896 8.43164 9.83398 7.83333 9.83398H5.66667C5.06836 9.83398 4.58333 9.34896 4.58333 8.75065Z" fill="white"/>
              </svg>
            </div>
            <div className="action-content">
              <h3>Upload Jobs from Excel</h3>
              <p>Bulk upload multiple job postings at once</p>
            </div>
            <div className="action-arrow">
              <svg width="12" height="20">
                <use href={`${icons}#arrow`}></use>
              </svg>
            </div>
          </div>
        </DialogContent>
      </div>
    </Dialog>
  );
};

export default MobileActionMenu;
